import { PaywallSocialProof } from "./PaywallModalContent";
import Translations from "@translate/components/AlphaPick/AlphaPickPricing/PaywallModalContent/socialProofMockData";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

enum ActionKey {
  IPO,
  Earnings,
  EdgenPick,
}

enum TimeAgoKey {
  Seconds,
  Minutes,
  Hours,
  Day,
  Days,
}

interface RawSocialProofItem {
  user: string;
  actionKey: ActionKey;
  timeAgoKey: TimeAgoKey;
  timeAgoValue: number;
}

/**
 * timeAgo 生成规则（请勿修改已有数据的时间字段）:
 * - Seconds: 1~59
 * - Minutes: 1~59
 * - Hours:   1~23（不超过 23，≥24 应转为 Day/Days）
 * - Day:     固定 1（单数天）
 * - Days:    2~3（不超过 3 天）
 */
const RAW_LIST: RawSocialProofItem[] = [
  {
    user: "A***n",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 25,
  },
  {
    user: "T***h",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 3,
  },
  {
    user: "b***u",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 1,
  },
  {
    user: "S***q",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Days,
    timeAgoValue: 2,
  },
  {
    user: "A***t",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 47,
  },
  {
    user: "H***e",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 12,
  },
  {
    user: "U***n",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 3,
  },
  {
    user: "E***N",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "O***j",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 8,
  },
  {
    user: "L***u",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 27,
  },
  {
    user: "T***l",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 5,
  },
  {
    user: "K***🔗",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Days,
    timeAgoValue: 3,
  },
  {
    user: "M***9",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 52,
  },
  {
    user: "D***n",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 6,
  },
  {
    user: "C***x",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 2,
  },
  {
    user: "T***e",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 23,
  },
  {
    user: "S***🏎",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 33,
  },
  {
    user: "L***h",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 19,
  },
  {
    user: "M***B",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 7,
  },
  {
    user: "h***m",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 18,
  },
  {
    user: "T***r",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 14,
  },
  {
    user: "N***e",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 41,
  },
  {
    user: "E***h",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 9,
  },
  {
    user: "H***s",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 15,
  },
  {
    user: "V***t",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 59,
  },
  {
    user: "D***n",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 8,
  },
  {
    user: "K***i",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 4,
  },
  {
    user: "K***a",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 20,
  },
  {
    user: "B***6",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 21,
  },
  {
    user: "N***2",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 35,
  },
  {
    user: "L***8",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 6,
  },
  {
    user: "O***j",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Days,
    timeAgoValue: 2,
  },
  {
    user: "G***e",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 38,
  },
  {
    user: "T***l",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 14,
  },
  {
    user: "b***0",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 11,
  },
  {
    user: "R***l",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 22,
  },
  {
    user: "T***h",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 5,
  },
  {
    user: "K***h",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 22,
  },
  {
    user: "b***0",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 8,
  },
  {
    user: "L***u",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 17,
  },
  {
    user: "c***💙",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 43,
  },
  {
    user: "P***i",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 51,
  },
  {
    user: "Q***h",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 13,
  },
  {
    user: "t***e",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 21,
  },
  {
    user: "소***기",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 17,
  },
  {
    user: "최***🌈",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 44,
  },
  {
    user: "김***준",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 16,
  },
  {
    user: "박***아",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 19,
  },
  {
    user: "이***현",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 29,
  },
  {
    user: "S***💚",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 9,
  },
  {
    user: "F***n",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 18,
  },
  {
    user: "N***k",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 14,
  },
  {
    user: "o***i",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 56,
  },
  {
    user: "M***✏️",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 17,
  },
  {
    user: "Q***i",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 21,
  },
  {
    user: "K***m",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 16,
  },
  {
    user: "A***e",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 11,
  },
  {
    user: "S***q",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 33,
  },
  {
    user: "H***e",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 23,
  },
  {
    user: "E***N",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 20,
  },
  {
    user: "J***s",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 42,
  },
  {
    user: "C***🐬",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 28,
  },
  {
    user: "G***a",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "L***s",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 23,
  },
  {
    user: "S***a",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 7,
  },
  {
    user: "O***j",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 46,
  },
  {
    user: "A***t",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "P***h",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 18,
  },
  {
    user: "k***g",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 34,
  },
  {
    user: "A***n",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 57,
  },
  {
    user: "M***🦎",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "o***n",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 22,
  },
  {
    user: "m***⚡",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 19,
  },
  {
    user: "s***i",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 13,
  },
  {
    user: "Z***5",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "J***x",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 15,
  },
  {
    user: "K***🔥",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 51,
  },
  {
    user: "K***n",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 39,
  },
  {
    user: "T***g",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "w***s",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 19,
  },
  {
    user: "p***g",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 26,
  },
  {
    user: "A***O",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 48,
  },
  {
    user: "a***0",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "m***.",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 16,
  },
  {
    user: "D***I",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 16,
  },
  {
    user: "c***h",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 55,
  },
  {
    user: "G***✨",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Day,
    timeAgoValue: 1,
  },
  {
    user: "a***8",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 21,
  },
  {
    user: "L***🔺",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 37,
  },
  {
    user: "d***1",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 24,
  },
  {
    user: "K***e",
    actionKey: ActionKey.IPO,
    timeAgoKey: TimeAgoKey.Hours,
    timeAgoValue: 14,
  },
  {
    user: "j***4",
    actionKey: ActionKey.Earnings,
    timeAgoKey: TimeAgoKey.Seconds,
    timeAgoValue: 44,
  },
  {
    user: "R***z",
    actionKey: ActionKey.EdgenPick,
    timeAgoKey: TimeAgoKey.Minutes,
    timeAgoValue: 31,
  },
];

function translateActionKey(key: ActionKey): string {
  switch (key) {
    case ActionKey.IPO:
      return I18n.t("unlocked the latest IPO Strategies");
    case ActionKey.Earnings:
      return I18n.t("unlocked the latest Earnings Forecast");
    case ActionKey.EdgenPick:
      return I18n.t("unlocked the latest Edgen's Pick");
  }
}

function translateTimeAgo(key: TimeAgoKey, value: number): string {
  switch (key) {
    case TimeAgoKey.Seconds:
      return I18n.t("%{var0}s ago", { var0: value });
    case TimeAgoKey.Minutes:
      return I18n.t("%{var0}m ago", { var0: value });
    case TimeAgoKey.Hours:
      return I18n.t("%{var0}h ago", { var0: value });
    case TimeAgoKey.Day:
      return I18n.t("%{var0} day ago", { var0: value });
    case TimeAgoKey.Days:
      return I18n.t("%{var0} days ago", { var0: value });
  }
}

const TIME_UNIT_TO_SECONDS: Record<TimeAgoKey, number> = {
  [TimeAgoKey.Seconds]: 1,
  [TimeAgoKey.Minutes]: 60,
  [TimeAgoKey.Hours]: 3600,
  [TimeAgoKey.Day]: 86400,
  [TimeAgoKey.Days]: 86400,
};

function toSeconds(item: RawSocialProofItem): number {
  return item.timeAgoValue * TIME_UNIT_TO_SECONDS[item.timeAgoKey];
}

/**
 * 从100条 mock 数据中随机取 limit 条，按时间由近到远排序
 * 调用时自动读取全局 locale，无需手动传参
 * @param limit 返回条数，默认20
 */
export function getSocialProofMockList(limit = 20): PaywallSocialProof[] {
  const shuffled = [...RAW_LIST].sort(() => Math.random() - 0.5);
  return shuffled
    .slice(0, limit)
    .sort((a, b) => toSeconds(a) - toSeconds(b))
    .map((item) => ({
      user: item.user,
      actionText: translateActionKey(item.actionKey),
      timeAgo: translateTimeAgo(item.timeAgoKey, item.timeAgoValue),
    }));
}
